/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Refresh_Aria_LabelInputs */

const en_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh Timeline`)
};

const fr_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser la chronologie`)
};

const de_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitleiste aktualisieren`)
};

const it_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna cronologia`)
};

const ru_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить временную шкалу`)
};

const es_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar la línea de tiempo`)
};

const zh_cn2_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新时间线`)
};

const ja_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインを更新`)
};

const hi_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन रीफ़्रेश करें`)
};

const pt_pt2_timeline_legacy_refresh_aria_label = /** @type {(inputs: Timeline_Legacy_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar linha do tempo`)
};

/**
* | output |
* | --- |
* | "Refresh Timeline" |
*
* @param {Timeline_Legacy_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_refresh_aria_label = /** @type {((inputs?: Timeline_Legacy_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "de") return de_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "it") return it_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "ru") return ru_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "es") return es_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "ja") return ja_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "hi") return hi_timeline_legacy_refresh_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_legacy_refresh_aria_label(inputs)
	return en_timeline_legacy_refresh_aria_label(inputs)
});